import { Component, inject, Input } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { BatterieSpeicherInformationen } from '../../../domain/model/batterie-speicher-informationen.model';
import { AbstractForm } from '../abstract-form.model';
import { FormGroupConfig } from '../form-config.model';
import { ErzeugungsanlageConfig } from '../erzeugungsanlage.config';
import { MatValidators } from '../../../common/material/components/mat-form-field-required.directive';
import { LeistungsValidator } from '../validator/leistungs.validator';
import { Feld } from '../../../domain/model/feld.enum';

@Component({
    selector: 'redispatch-batteriespeicher-sub-form',
    templateUrl: './batteriespeicher-sub-form.component.html',
    styleUrls: [
        './batteriespeicher-sub-form.component.scss',
    ],
    standalone: false,
})
export class BatteriespeicherSubFormComponent extends AbstractForm<BatterieSpeicherInformationen> {

    public readonly LYT_GAP = ErzeugungsanlageConfig.HORIZONTAL_FX_LAYOUT_GAP;
    public readonly Feld = Feld;

    @Input({ required: true }) disabled: boolean;
    @Input({ required: true }) readonly: boolean;

    constructor() {
        super(inject(UntypedFormBuilder));
    }

    get formGroupConfig(): FormGroupConfig<BatterieSpeicherInformationen> {
        return {
            wirkleistungAusspeichernMax: [
                {
                    value: null,
                    disabled: this.disabled || this.readonly,
                },
                [
                    MatValidators.required,
                    ...LeistungsValidator.validator3,
                ],
            ],
            nutzbarerEnergieinhaltSpeichers: [
                {
                    value: null,
                    disabled: this.disabled || this.readonly,
                },
                [
                    MatValidators.required,
                    ...LeistungsValidator.validator6,
                ],
            ],
        };
    }

    public sanitize(infos: BatterieSpeicherInformationen): BatterieSpeicherInformationen {
        return infos;
    }

}
